import React, { Fragment } from 'react';
import styled from 'react-emotion';

const HeroCallout = styled.div`
  padding: 20px;
  color: ${props => props.theme.primaryLight};
  flex-shrink: 0;

  @media (min-width: 768px) {
    padding: 0px;
    width: 45%;
    margin-left: 5em; 
  }

  & p {
    margin: 0;
    margin-bottom: .5em;
    font-size: 20px;
    line-height: 1.55em;
  }

  & h6 {
    font-weight: normal;
    text-transform: uppercase;
    color: ${props => props.theme.primaryLight};
    font-size: 16px;
    margin: 0;
  }

  & h1 {
    color: ${props => props.theme.white};
    margin-bottom: .25em;
  }
`;

export default HeroCallout;


// WEBPACK FOOTER //
// ./src/components/Common/HeroCallout/index.js